<ion-radio-group
  *ngIf="
    option &&
    option.choices &&
    option.choices.length &&
    !option.always_split_columns &&
    !(
      (option.mo_image_card_choices || option.mo_only_image_card_choices) &&
      !option.quantityInChoices
    )
  "
  [allowEmptySelection]="!option?.is_require"
  (ionChange)="onChoiceSelectedChange($event)"
  [(ngModel)]="selectedChoiceId"
>
  <div *ngFor="let choice of option.choices; trackBy: trackFn">
    <app-no-image-radio-choice
      *ngIf="!checkForImage(choice)"
      [option_id]="option_id"
      [choice_id]="choice.choice_id"
      [selectedProductId]="selectedProductId"
      [alt_dinein_active]="alt_dinein_active"
      [groupStoreData]="groupStoreData"
    ></app-no-image-radio-choice>

    <app-image-radio-choice
      *ngIf="checkForImage(choice)"
      [option_id]="option_id"
      [choice_id]="choice.choice_id"
      [imagePath]="imagePath"
      [selectedProductId]="selectedProductId"
      [alt_dinein_active]="alt_dinein_active"
      [groupStoreData]="groupStoreData"
    ></app-image-radio-choice>
  </div>
</ion-radio-group>

<ion-radio-group
  [allowEmptySelection]="!option?.is_require"
  (ionChange)="onChoiceSelectedChange($event)"
  [(ngModel)]="selectedChoiceId"
  *ngIf="
    option &&
    option.choices &&
    option.choices.length &&
    option.always_split_columns &&
    !(
      (option.mo_image_card_choices || option.mo_only_image_card_choices) &&
      !option.quantityInChoices
    )
  "
>
  <ion-row
    style="width: 100%"
    class="ion-no-padding ion-no-margin"
    class="ion-align-items-center"
  >
    <ion-col
      *ngFor="let choice of option.choices; trackBy: trackFn"
      [size]="colSize"
      class="ion-no-padding ion-no-margin"
    >
      <app-no-image-radio-choice
        *ngIf="!checkForImage(choice)"
        [option_id]="option_id"
        [choice_id]="choice.choice_id"
        [selectedProductCategory]="selectedProductCategory"
        [selectedProductPromo]="selectedProductPromo"
        [selectedProductId]="selectedProductId"
        [alt_dinein_active]="alt_dinein_active"
        [groupStoreData]="groupStoreData"
      ></app-no-image-radio-choice>

      <app-image-radio-choice
        *ngIf="checkForImage(choice)"
        [option_id]="option_id"
        [choice_id]="choice.choice_id"
        [selectedProductCategory]="selectedProductCategory"
        [selectedProductPromo]="selectedProductPromo"
        [imagePath]="imagePath"
        [selectedProductId]="selectedProductId"
        [alt_dinein_active]="alt_dinein_active"
        [groupStoreData]="groupStoreData"
      ></app-image-radio-choice>
    </ion-col>
  </ion-row>
</ion-radio-group>

<!-- Card-design choices (non-quantity options only) -->
<div
  class="dm-cards-container"
  *ngIf="
    option &&
    option.choices &&
    option.choices.length &&
    option.mo_image_card_choices &&
    !option.quantityInChoices
  "
>
  <ion-row
    style="width: 100%"
    class="ion-align-items-stretch ion-justify-content-center"
  >
    <ng-container *ngFor="let choice of option.choices; trackBy: trackFn">
      <ion-col
        *ngIf="!option.quantityInChoices && checkForImage(choice)"
        [size]="imageCardColSize"
        class="ion-no-padding"
      >
        <app-image-card-radio-choice
          [option_id]="option_id"
          [choice_id]="choice.choice_id"
          [imagePath]="imagePath"
          [selectedProductId]="selectedProductId"
          [selectedProductPromo]="selectedProductPromo"
          [selectedProductCategory]="selectedProductCategory"
          [alt_dinein_active]="alt_dinein_active"
          [groupStoreData]="groupStoreData"
          [selectedChoiceId]="selectedChoiceId"
          (choiceChanged)="cardRadioChoiceChanged($event)"
        ></app-image-card-radio-choice>
      </ion-col>
    </ng-container>
  </ion-row>
</div>

<div
  class="dm-cards-container"
  *ngIf="
    option &&
    option.choices &&
    option.choices.length &&
    option.mo_only_image_card_choices &&
    !option.mo_image_card_choices &&
    !option.quantityInChoices
  "
>
  <ion-row
    style="width: 100%"
    class="ion-align-items-stretch ion-justify-content-center"
  >
    <ng-container *ngFor="let choice of option.choices; trackBy: trackFn">
      <ion-col
        *ngIf="!option.quantityInChoices && checkForImage(choice)"
        [size]="onlyImageCardColSize"
        class="ion-no-padding"
      >
        <app-only-image-radio-choice
          [option_id]="option_id"
          [choice_id]="choice.choice_id"
          [imagePath]="imagePath"
          [selectedProductId]="selectedProductId"
          [selectedProductPromo]="selectedProductPromo"
          [selectedProductCategory]="selectedProductCategory"
          [alt_dinein_active]="alt_dinein_active"
          [groupStoreData]="groupStoreData"
          [selectedChoiceId]="selectedChoiceId"
          (choiceChanged)="cardRadioChoiceChanged($event)"
        ></app-only-image-radio-choice>
      </ion-col>
    </ng-container>
  </ion-row>
</div>
